import * as tslib_1 from "tslib";
import { ClientSvcQueryable, MethodParams, property, } from "@pnp/sp-clientsvc";
import { stringIsNullOrEmpty } from "@pnp/common";
/**
 * Represents a collection of labels
 */
var Labels = /** @class */ (function (_super) {
    tslib_1.__extends(Labels, _super);
    function Labels(parent, _objectPaths) {
        if (parent === void 0) { parent = ""; }
        if (_objectPaths === void 0) { _objectPaths = null; }
        var _this = _super.call(this, parent, _objectPaths) || this;
        _this._objectPaths.add(property("Labels"));
        return _this;
    }
    /**
     * Gets a label from the collection by its value
     *
     * @param value The value to retrieve
     */
    Labels.prototype.getByValue = function (value) {
        var params = MethodParams.build().string(value);
        return this.getChild(Label, "GetByValue", params);
    };
    /**
     * Loads the data and merges with with the ILabel instances
     */
    Labels.prototype.get = function () {
        var _this = this;
        return this.sendGetCollection(function (d) {
            if (!stringIsNullOrEmpty(d.Value)) {
                return _this.getByValue(d.Value);
            }
            throw Error("Could not find Value in Labels.get(). You must include at least one of these in your select fields.");
        });
    };
    return Labels;
}(ClientSvcQueryable));
export { Labels };
/**
 * Represents a label instance
 */
var Label = /** @class */ (function (_super) {
    tslib_1.__extends(Label, _super);
    function Label() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets the data for this Label
     */
    Label.prototype.get = function () {
        return this.sendGet(Label);
    };
    /**
     * Sets this label as the default
     */
    Label.prototype.setAsDefaultForLanguage = function () {
        return this.invokeNonQuery("SetAsDefaultForLanguage");
    };
    /**
     * Deletes this label
     */
    Label.prototype.delete = function () {
        return this.invokeNonQuery("DeleteObject");
    };
    return Label;
}(ClientSvcQueryable));
export { Label };
//# sourceMappingURL=labels.js.map